<app-header></app-header>
<app-sidebar></app-sidebar>

<div class="content-wrapper" style="min-height: 307px">
    <section *ngIf="userdata.userlevel == 15" id="forPartcode">
        <!-- รายการขอแก้ไขแปลงของ Partcode -->
        <div class="row">
            <div class="col-lg-12">
                <div id="listRequest" class="card card-outline card-success ml-2 mr-2">
                    <div class="card-header">
                        <h3 class="card-title "><span class="headText2">รายการขอแก้ไขข้อมูลแปลงอ้อยของท่าน</span></h3>
                        <div class="card-tools ">
                            <button type="button" class="btn btn-tool text-primary" data-card-widget="maximize"><i
                                    class="fas fa-expand"></i></button>
                            <button (click)="requestDataPart();" type="button" class="btn btn-tool text-primary"><i
                                    class="fas fa-sync-alt"></i></button>
                            <button type="button" class="btn btn-tool text-primary" data-card-widget="collapse"><i
                                    class="fas fa-minus"></i>
                            </button>
                        </div>
                    </div>
                    <div class="card-body table-responsive p-2" style="height: 400px">
                        <table #tb_dataPart class="table table-hover table-head-fixed text-nowrap">
                            <thead>
                                <tr class="headText text-primary">
                                    <th>วันที่</th>
                                    <th>ข้อมูลแปลง</th>
                                    <th>หัวข้อ</th>
                                    <th>เหตุผล</th>
                                    <th>สถานะ</th>
                                    <th class="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of dataPart">
                                    <td class="align-middle">{{ item.date_add | adtob }}</td>
                                    <td class="align-middle">
                                        {{ item.intlandno }} {{ item.fmname }} {{ item.canetype }}
                                        {{ item.landvalue }} ไร่ รูท {{ item.route }}
                                    </td>
                                    <td>{{ item.edit_type_name }}</td>
                                    <td>{{ item.comment }}</td>
                                    <td>{{ item.edit_status_doc }}</td>
                                    <!-- <td [ngClass]="[ item.schedule==1 && item.status_sv !=5 ? 'bg-warning align-middle' : 'align-middle' ]">{{ item.date_schedule | adtob }}</td> -->
                                    <td class="text-center align-middle">
                                        <a *ngIf="item.edit_status==0" [routerLink]="['/editplotpartform',item.itid,item.edit_ID]" target="_blank">
                                            <i class="fas fa-edit"></i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>



<app-footer></app-footer>